import { render, staticRenderFns } from "./matterInfo.vue?vue&type=template&id=58912edc&"
import script from "./matterInfo.vue?vue&type=script&lang=js&"
export * from "./matterInfo.vue?vue&type=script&lang=js&"
import style0 from "./matterInfo.vue?vue&type=style&index=0&id=58912edc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports